const config = {
  apiGateway: {
    REGION: 'us-west-2',
    INTERNAL_API_URL: 'https://d4o4va7e68.execute-api.us-west-2.amazonaws.com/prod',
    TARGET_API_URL: 'https://noky454v5h.execute-api.us-west-2.amazonaws.com/api',
    TEAMS_APP_URL: 'https://teams.pas.forwoodsafety.com/teams',
    QS_DASHBOARD_URL: '',
    CLIENT_TIMEZONE: 'America/Sao_Paulo'
  },
  reactApp: {
    VERSION: 'targets-1.12.1',
    HOSTNAME: 'https://targets.pas.forwoodsafety.com'
  }
};

export default config;